import React, {Component} from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Row, Col } from 'reactstrap';
import NameComponent from './NameComponent';

class DropDownComponent extends Component {
    constructor(props){
        super(props)

    }

    render(){
        return(
            <div style = {{ marginBottom: 10, flexDirection:'row',display:'flex', width:'100%', alignItems:'center', alignContent:'center'}} className = { !this.props.Selected ? "" : "border-bottom border-info"}>
                <div style = {{width:'25%', marginRight:20}}>
                    <NameComponent text = {this.props.Title} backgroundColor = {'#E6E6E6'} />
                </div>
                <div style = {{width:this.props.Title ? '40%' : '100%'}}>
                    <Dropdown isOpen={this.props.isOpen}  style = {{width:'100%'}} toggle={() => {
                        this.props.toggle()
                        }}>
                        <DropdownToggle caret style = {{width:'100%'}}
                            color = "light"
                        >
                            {this.props.Value}
                        </DropdownToggle>
                        <DropdownMenu  style = {{width:'100%'}}>
                            {this.props.children}
                        </DropdownMenu>
                    </Dropdown>
                </div>
                
            </div>
        )
    }
}

export default DropDownComponent